__webpack_require__.p = "/wp-content/themes/lwetb/courses-form-react/";